// feedService.js
// Service for feed-related API calls: feed, search, bet details, odds, active sports

import { POST, GET, BASE_URL } from './httpClient';

/**
 * Feed and betting data functions
 */

// Function to get the main betting feed
export const getFeed = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/feed`, request);
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching feed:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to search the feed
export const getFeedSearch = async (searchTerm) => {
    try {
        const response = await POST(`${BASE_URL}/feed/search`, {
            searchTerm: searchTerm
        });
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching feed search:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to get detailed bet information
export const getBetDetails = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/feed/betDetails`, request);
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching indepth bet:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to get odds data
export const getOdds = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/odds`, request);
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching odds:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to get active sports
export const getActiveSports = async () => {
    try {
        const response = await GET(`${BASE_URL}/feed/sports`);
        return response;
    } catch (error) {
        console.error('Error fetching active sports:', error);
        throw error;
    }
};

